module.exports = __webpack_public_path__ + "img/ios_step3.6da2c0f1.png";